import * as React from 'react';
import cx from 'clsx';

import JackpotNumber from '../JackpotNumber/JackpotNumber';
import JackpotCountdown from '../JackpotCountdown/JackpotCountdown';

import {
  JackpotTier,
  JackpotBoxScale,
  WrapperType,
  JackpotStaticTexts,
} from '../../types';

import styles from './JackpotBox.module.scss';

interface JackpotBoxPropsInterface extends JackpotTier {
  curValue: number;
  winValue?: number;
  animateValue?: boolean;
  scale: JackpotBoxScale;
  currencyCode: string;
  locale: string;
  valueAnimationDuration: number;
  isOverlay?: boolean;
  wrapperType: WrapperType;
  timeStaticTexts: JackpotStaticTexts['time'];
}

const JackpotBox = ({
  curValue,
  winValue,
  scale,
  currencyCode,
  locale,
  name,
  state,
  winMessage,
  nextJackpotName,
  releaseTime,
  releaseMessage,
  valueAnimationDuration,
  isOverlay,
  wrapperType,
  timeStaticTexts,
}: JackpotBoxPropsInterface) => (
  <div
    className={cx(
      styles.container,
      state === 'won' ? styles.won : styles.normal,
      scale === 'tiny' && styles.tiny
    )}
    data-testid="jackpot-box-holder"
  >
    {(isOverlay || state !== 'won') && (
      <div>
        <div className={styles.jackpotNameContainer}>
          <div className={styles.jackpotName}>
            <span
              className={cx({
                [styles.jackpotNameTiny]: scale === 'tiny',
                [styles.jackpotNameSmall]: scale === 'small',
                [styles.jackpotNameMedium]: scale === 'medium',
              })}
            >
              {name}
            </span>
            {winMessage && (
              <span className={styles.jackpotMessage}>{winMessage}</span>
            )}
          </div>
        </div>
        <div className={styles.jackpotValue}>
          <JackpotNumber
            currencyCode={currencyCode}
            value={winValue || curValue}
            valueAnimationDuration={isOverlay ? 0 : valueAnimationDuration}
            jackpotScale={scale}
            jackpotState={state}
            locale={locale}
            wrapperType={wrapperType}
          />
        </div>
        {state !== 'won' && scale !== 'medium' && (
          <JackpotCountdown
            jackpotScale={scale}
            jackpotState={state}
            releaseTime={releaseTime}
            releaseMessage={releaseMessage}
            timeStaticTexts={timeStaticTexts}
          />
        )}{' '}
      </div>
    )}
    {state === 'won' && (
      <div className={styles.nextContainer}>
        <div className={styles.jackpotNameContainer}>
          <span className={cx(styles.jackpotName, styles.jackpotNameSmall)}>
            {nextJackpotName}
          </span>
        </div>
        <div className={styles.jackpotValue}>
          <JackpotNumber
            currencyCode={currencyCode}
            value={curValue}
            valueAnimationDuration={valueAnimationDuration}
            jackpotScale={'small'}
            jackpotState={'normal'}
            locale={locale}
            wrapperType={wrapperType}
          />
        </div>
      </div>
    )}
  </div>
);

export default React.memo(JackpotBox);
